import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const Ctx = createContext(null);

export function AuthProvider({ children }) {
  const [me, setMe] = useState(null);
  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setMe(data);
      return data;
    } catch {
      setMe(false);
      return false;
    }
  }, []);
  useEffect(() => { refresh(); }, [refresh]);
  return <Ctx.Provider value={{ me, refresh, setMe }}>{children}</Ctx.Provider>;
}

export const useAuth = () => useContext(Ctx);
export const isAdmin = (me) => me && ["owner", "admin"].includes(me.role);
